import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { duckify } from "utils/duckify";
import { feeGroups } from '../../ducks';

import FeeGroupModal from './FeeGroupModal';
import FeeGroupListWrapper from './FeeGroupListWrapper';

import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import FontAwesome from 'utils/FA';

const AddNewFeeGroup = ({ feeGroups }) => {

  const [showModal, setShowModal] = useState(false);

  return (
    <React.Fragment>
      <a className="add-item-button fee-entity-add" href="#" onClick={() => setShowModal(true)}>
        <FontAwesome icon={faPlusCircle} /> Add a new fee group
      </a>
      {feeGroups.length <= 0 &&
        <div className="fee-groups-empty card card-body bg-light">
          No fee groups have been configured yet.
        </div>
      }
      {feeGroups.length > 0 &&
        <FeeGroupListWrapper />
      }
      {showModal &&
        <FeeGroupModal closeModal={() => setShowModal(false)} />
      }
    </React.Fragment>
  )
}

const mapDucksToProps = () => ({ feeGroups });

AddNewFeeGroup.propTypes = {
  feeGroups: PropTypes.array
};

export default duckify(mapDucksToProps)(AddNewFeeGroup);